<template>
  <database-management
    :headings="headings"
    :entries="entries"
    :loading="loading"
    :sort="sort"
    :sort-dir="sortDir"
    :allow-create="false"
    @showModal="(id) => {
      selectedEntryId = id
      showModal()
    }"
    @updateSort="(key) => {
      updateSort(key)
    }">
    <template v-slot:heading>Region Management</template>
    <template v-slot:list>
      <region-management-list-item
        v-for="region in sortedEntries"
        :key="region.id"
        :region="region"
        @edit="(id) => {
            selectedEntryId = id
            showModal()
          }"/>
    </template>
    <template v-slot:modal>
      <region-management-modal
        ref="modal"
        :region="selectedEntryIndex !== -1 ? entries[selectedEntryIndex] : defaultEntry"
        @update="(region) => { update(region) }"
      />
    </template>
  </database-management>
</template>

<script>
import { http } from 'utils'
import DatabaseManagement from './templates/DatabaseManagement'
import { databaseManagement } from 'mixins'
import RegionManagementListItem from './RegionManagementListItem'
import RegionManagementModal from './RegionManagementModal'

export default {
  mixins: [databaseManagement],
  components: { RegionManagementModal, RegionManagementListItem, DatabaseManagement },
  data () {
    return {
      categories: [],
      defaultEntryData: {
        admin_email: null,
        from_email: null
      },
      headings: [
        { key: 'name', label: 'Name' },
        { key: 'admin_email', label: 'Admin Email' },
        { key: 'from_email', label: 'From Email' }
      ]
    }
  },

  created () {
    http.get('regions')
      .then((response) => {
        this.entries = response.data
        this.loading = false
      })
  }
}
</script>
